<template>
  <Button
    v-bind="{ ...props, icon: undefined }"
    :class="{
      'h-control': size === 'small',
      'h-[48px]': size === 'large',
    }"
  >
    <div
      v-if="!loading"
      class="flex w-full items-center justify-center gap-[7px] text-inherit"
      :class="{
        'flex-row': iconAlign === 'left' || !iconAlign,
        'flex-row-reverse': iconAlign === 'right',
      }"
    >
      <Icon v-if="icon" :name="icon" :class="iconClass" />
      <span v-if="label" :class="cx({ 'v3-body-bold-700-line-height-1.2': props.bold }, labelClass)">{{
        label
      }}</span>
    </div>
    <div
      v-else
      class="flex w-full items-center justify-center gap-[7px] text-inherit"
      :class="{ 'flex-row-reverse': iconAlign === 'right' }"
    >
      <Icon
        name="spinner"
        :class="cx('animate-spin', label ? 'size-[18px]' : undefined, iconClass)"
      />
      <span
        v-if="label"
        :class="cx({ 'v3-body-bold-700-line-height-1.2': props.bold }, labelClass)"
      >{{ label }}</span>
    </div>
  </Button>
</template>

<script lang="ts" setup>
import type { ButtonProps } from 'primevue/button';
import Button from 'primevue/button';

import Icon from '@/common/components/atoms/Icon';
import { cx } from '@/helpers/cva';

interface Props extends /* @vue-ignore */ ButtonProps {
  bold?: boolean;
  icon?: string | undefined;
  iconAlign?: 'left' | 'right' | undefined;
  iconClass?: string | undefined;
  loading?: boolean;
  label?: string | undefined;
  disabled?: boolean;
  labelClass?: string | object | undefined;
  size?: 'small' | 'large';
}

const props = withDefaults(defineProps<Props>(), {
  bold: true,
  iconAlign: undefined,
  loading: false,
  icon: undefined,
  iconClass: undefined,
  labelClass: undefined,
  label: undefined,
  disabled: false,
  size: 'small',
});
</script>

<style scoped>
  .p-button.p-button-tertiary:hover, .p-button.p-button-tertiary.active {
    background-color: var(--color-brand-forrest-green-10);
    color: var(--v3-theme-primarycolor);
    border-color: var(--color-brand-forrest-green-80);
  }
</style>
